"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _text = require("./text.tokens");
var _tokens = _interopRequireDefault(require("../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledDetail = _styledComponents.default.div.withConfig({
  displayName: "Detail__StyledDetail",
  componentId: "sc-1m22c2i-0"
})(["display:inline-block;", " color:", ";cursor:inherit;white-space:", ";"], function (_ref) {
  var size = _ref.size;
  return _tokens.default.sky.sys.font.detail[size];
}, function (_ref2) {
  var color = _ref2.color;
  return _text.tokens.color.detail[color];
}, function (_ref3) {
  var noWrap = _ref3.noWrap;
  return noWrap ? 'nowrap' : 'pre-wrap';
});
var Detail = function Detail(_ref4) {
  var children = _ref4.children,
    size = _ref4.size,
    color = _ref4.color,
    noWrap = _ref4.noWrap,
    props = _objectWithoutProperties(_ref4, ["children", "size", "color", "noWrap"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDetail, _objectSpread({
    size: size,
    color: color,
    noWrap: noWrap
  }, props, {
    children: children
  }));
};
Detail.defaultProps = {
  size: '1',
  color: 'default',
  noWrap: false
};
var _default = exports.default = Detail;